var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"votes"},[_c('div',{staticClass:"contain"},[_c('VoteComp',{attrs:{"like":"86","unlike":"23"}}),_c('VoteComp',{attrs:{"like":"62","unlike":"33"}}),_c('VotePage')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }